<div
  tabindex="0"
  [ngClass]="{
    'laptop:max-h-[calc(100dvh-100px)]': !isAlertAdvisory,
    'laptop:max-h-[calc(100dvh-200px)]': isAlertAdvisory
  }"
  class="w-full tablet:w-full laptop:w-[370px] focus:outline-none flex flex-col laptop:block laptop:overflow-y-auto min-h-0 laptop:h-auto portrait:h-full landscape:h-auto"
  id="flyout-tracker--container"
>
  <div class="flex-shrink-0">
    <idp-flyout-account-summary-header
      *ngIf="accountSummaryHeaderContent.firstName"
      [content]="accountSummaryHeaderContent"
      (close)="close()"
    ></idp-flyout-account-summary-header>
  </div>

  <div
    *ngIf="
      todayTabContent.todayTrip &&
      todayTabContent.todayTrip.scheduleFlightDepartureTime
    "
    class="tabs focus:outline-none mx-[16px] mt-[16px] flex-shrink-0"
    id="flyout-tabs"
    tabindex="0"
    (keydown.ArrowRight)="switchTab(1)"
    (keydown.ArrowLeft)="switchTab(0)"
  ></div>

  <div
    class="overflow-y-auto flex-1 min-h-0 max-h-full portrait:overflow-y-auto landscape:overflow-visible laptop:min-h-[256px] laptop:flex-none laptop:overflow-visible laptop:max-h-none"
    *ngIf="selectedTab === 0"
  >
    <idp-flyout-today [content]="todayTabContent"></idp-flyout-today>
  </div>
  <div
    class="overflow-y-auto flex-1 min-h-0 max-h-full mt-16 portrait:overflow-y-auto landscape:overflow-visible laptop:min-h-[370px] laptop:max-h-[500px] laptop:flex-none laptop:mt-16 laptop:overflow-visible"
    *ngIf="selectedTab === 1"
  >
    <idp-flyout-status-tracker
      [content]="statusTracker"
      (analyticsData)="trackData($event)"
      (errorAnalyticsData)="errorAnalyticsData.emit($event)"
    ></idp-flyout-status-tracker>
  </div>
  <div class="flex-shrink-0 mt-auto laptop:mt-0 laptop:h-[48px]">
    <idp-flyout-footer
      [content]="footerContent"
      (logoutEvent)="logoutEvent.emit()"
      (analyticsData)="trackData($event)"
    ></idp-flyout-footer>
  </div>
</div>
